import { Link } from "react-router-dom";

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  rating: number;
  views: number;
  status: string;
  tags: string[];
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  rating,
  views,
  status,
  tags,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4]">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2">
          <span
            className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
              status === "连载中"
                ? "bg-primary-500 text-background-50"
                : "bg-secondary-500 text-background-50"
            }`}
          >
            {status}
          </span>
        </div>
        <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-black/60 rounded-full px-2 py-0.5">
          <i className="ri-star-fill text-yellow-400 text-xs"></i>
          <span className="text-xs text-white font-medium">{rating}</span>
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-0.5">{author}</p>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-400">
            <i className="ri-eye-line mr-0.5"></i>
            {formatViews(views)}
          </span>
          <div className="flex flex-wrap gap-1">
            {tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}